window._define('common/preferences', ['app/core'], function (core) { 'use strict';
    return core.getPreferences();
});
